import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewContainerRef
} from '@angular/core';
import { AnalyticsClick, Card } from '@com-delta-idp/mnx-skymiles-shared';
import { MembershipCardComponent } from '../membership-card/membership-card.component';
import { MembershipCard } from '../membership-card/models/membership-card.interfaces';
import { QuickLinks } from './models/quick-links.interfaces';

@Component({
  selector: 'idp-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrls: ['./quick-links.component.scss']
})
export class QuickLinksComponent {
  @Input() content: QuickLinks = {} as QuickLinks;
  @Output() clickAnalyticsEvent = new EventEmitter<AnalyticsClick>();

  constructor(public viewContainerRef: ViewContainerRef) {}

  clickAnalytics(card: Card, index: number) {
    const analyticsData: AnalyticsClick = {
      id: card.id ?? '',
      type: 'tile',
      position: index + 1 + ' of ' + this.content.cards.length,
      source: 'page content',
      name: this.getContent(card.content.title),
      sub_type: 'award',
      image: card.image.src,
      subSection: this.content.title,
      title: this.getContent(card.content.title)
    };
    this.clickAnalyticsEvent.emit(analyticsData);
    if (card.action.type === 'notify')
      this.createMemberShipCard(this.content.membershipCard);
  }

  getContent(title: string | undefined) {
    return title ?? '';
  }

  createMemberShipCard(membershipCard: MembershipCard) {
    const componentRef = this.viewContainerRef.createComponent(
      MembershipCardComponent
    );
    componentRef.instance.content = !membershipCard.image.src.includes(
      window.location.origin
    )
      ? this.updateCardUrls(membershipCard)
      : membershipCard;
  }

  updateCardUrls(membershipCard: MembershipCard): MembershipCard {
    membershipCard.image.src =
      window.location.origin + membershipCard.image.src;
    membershipCard.barcode.src =
      window.location.origin + membershipCard.barcode.src;
    return membershipCard;
  }
}
